import React from 'react';

import CustomToaster from '@components/CustomToaster';
import Spinner from '@components/Spinner';
import {
  useCurrentUser,
  useGiftSubscriptionSettings,
  useGroupSubscriptionsRecipients,
} from '@hooks';
import { GROUP_SUBSCRIPTION_GIFT } from '@src/constants';

import SubscriptionOverview from '../GroupSubscription/SubscriptionOverview';
import GiftForm from './GiftForm';
import styles from './styles.module.scss';

const Gift = () => {
  const { data: recipients, isLoading } = useGroupSubscriptionsRecipients(GROUP_SUBSCRIPTION_GIFT);
  const { currentUser, isLoadingCurrentUser } = useCurrentUser();
  const { giftSubscriptionSetting, isGiftSettingsLoading } = useGiftSubscriptionSettings();
  const canAccessGiftSubscription = currentUser?.settings_access_obj?.gift_sub_access;

  return (
    <>
      <CustomToaster />
      <>
        {isLoading || isLoadingCurrentUser || isGiftSettingsLoading ? (
          <Spinner />
        ) : (
          <>
            <div className={styles.giftSectionHeader}>
              <div className={styles.settingsSectionHeadingText}>Gift The Information</div>
              <div className={styles.settingsSectionHeadingLine}></div>
            </div>
            <div className={styles.giftSubHeader} id="GiftSubHeader">
              {canAccessGiftSubscription ? (
                <>
                  You can give others access to The Information. Share as a gift or with your
                  team—add additional subscribers for $
                  {giftSubscriptionSetting?.offer?.initialPrice} a year per person.
                </>
              ) : (
                <>
                  You can give others access to The Information. Share as a gift or with your team.
                  You do not currently have access to this program, but if you would like to get
                  access email{' '}
                  <a
                    className="!text-secondary-blue hover:opacity-80"
                    href="mailto:support@theinformation.com"
                  >
                    support@theinformation.com
                  </a>
                </>
              )}
            </div>
            {canAccessGiftSubscription && (
              <>
                <div className={styles.giftForms}>
                  <GiftForm />
                </div>
                <div className={styles.giftSectionHeader}>
                  <div className={styles.settingsSectionHeadingText}>Subscriptions</div>
                  <div className={styles.settingsSectionHeadingLine}></div>
                </div>
                <div className={styles.giftSubHeader} id="GiftSubHeader">
                  You are currently supporting the following subscriptions for others to The
                  Information
                </div>
                <SubscriptionOverview
                  recipients={recipients}
                  groupSubscriptionType={GROUP_SUBSCRIPTION_GIFT}
                />
              </>
            )}
          </>
        )}
      </>
    </>
  );
};

export default Gift;
